import { Auth, MyAccount } from "@cleeng/mediastore-sdk";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Logout from "../../../components/Logout";
import { API_URL } from "../../../constants";
import { axiosConfig } from "../../../utils";

function MyAccountPage() {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const planDetails = useSelector(state => state.planDetails)
  const { search, pathname } = useLocation();
  const query = new URLSearchParams(search);

  const tab = query.get("tab");
  const customCancellationReasons = [
    { value: "My child has grown out of it", key: "grown-out" },
    { value: "Subscription is too expensive", key: "expensive" },
    { value: "Technical issues", key: "technical-issues" },
    { value: "Poor customer support", key: "customer-support" },
    { value: "Other", key: "Other" },
  ];
  const getOffers = async () => {
    try {
      const res = await axios.get(
        `${API_URL}/offers?status=active&pageLimit=3`,
        axiosConfig(),
      );

      const listPlans = (res && res.data && res.data.responseData) || [];
      return listPlans;
    } catch (error) {
    }
  };
  const key = localStorage.getItem("CLEENG_CUSTOMER_EMAIL");

  const handleShowImages = async () => {
    const res = await getOffers()
    setPlans(res || [])
  }

  useEffect(() => {
    if (!Auth.isLogged()) {
      localStorage.setItem('save_redirect_url', pathname + search)
      navigate("/", { replace: true });
    }
    handleShowImages()
    const menu = document.querySelectorAll(".msd__account-sidebar__items>div")
    menu.forEach((item, index) => {
      item.addEventListener("click", (e) => {
        navigate(['/my-account', '/my-account?tab=your-payments', '/my-account?tab=update-profile'][index])
      });
    })
    document.title = "My Account - Super Simple";
    const description = document.querySelector('meta[name="description"');
    description.setAttribute("content", "Manage your Super Simple App account");
    // eslint-disable-next-line
    return () => {
      document.title = "Accounts - Super Simple";
      description.setAttribute("content", "Super Simple App account creation and management");
    }
  }, []);

  useEffect(() => {
    if (tab) {
      const menu = document.querySelectorAll(".msd__account-sidebar__items>div")
      const activeMenu = ({
        'your-payments': menu[1],
        'update-profile': menu[2]
      }[tab])
      activeMenu && activeMenu.click()
    }
  }, [tab])

  useEffect(() => {
    if (planDetails && planDetails.currentPlan && !planDetails.currentPlan.length) {
      const box = document.querySelector('.msd__info-box')

      const pushUrl = (href) => {
        window.history.pushState({}, '', href);
        window.dispatchEvent(new Event('popstate'));
      };
      if (box) {
        const btn = document.querySelector('btn.msd__button.msd__button--confirm')

        const createButton = document.createElement('button')
        createButton.innerText = 'Choose a plan'
        createButton.className = "btn msd__button msd__button--confirm";
        createButton.onclick = () => pushUrl(`/choose-plan`)
        !btn && box.appendChild(createButton)
      }
    }
  }, [planDetails])

  useEffect(() => {
    if (plans && plans.length) {
      const intervalId = setInterval(() => {
        const selectors = document.querySelectorAll('.msd__subscription-card__icon')
        const titleElements = document.querySelectorAll('.msd__subscription-text__title')
        const priceIndexs = []
        titleElements.forEach(e => {
          const index = plans.findIndex(p => p.title === e.innerText);
          priceIndexs.push(index)
        })
        for (let index = 0; index < selectors.length; index++) {
          const selector = selectors[index];
          const offer = plans[priceIndexs[index]]
          if (offer) {
            selector.style = `background-image: url("${offer.imageUrl}");background-size: cover;color: transparent;`
          }
        }
      }, 400)
      return () => clearInterval(intervalId);
    }
  }, [plans])
  return (
    <>
      <Logout />
      <MyAccount
        key={key}
        customCancellationReasons={customCancellationReasons}
        skipAvailableDowngradesStep
        displayGracePeriodError
      />
    </>
  );
}

export default MyAccountPage;
